var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a224eab0e8307ff0133a91ea32827e3e56b058c1423349fb93f3ffb6388480f5",
    x1: 44.59,
    y1: 78.03,
    x2: 150.83,
    y2: 78.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 97.79,
    cy: 78.98,
    r: 12.77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M80.68 99.89a22.09 22.09 0 0134.24 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M149.58 87.74V68.32h-10a42.49 42.49 0 00-5.08-12.44l7.66-7.66-13.73-13.74-7.5 7.5a42.86 42.86 0 00-13.21-5.61V26.16H88.3v10.11a42.91 42.91 0 00-12.37 4.92L69 34.27 55.28 48l6.61 6.6A42.45 42.45 0 0056 68.32H45.84v19.42H56a42.58 42.58 0 005.68 13.53l-6.57 6.57 13.69 13.74 6.73-6.73A42.73 42.73 0 0088.3 120v9.91h19.42v-10a42.51 42.51 0 0013.59-5.91l7.33 7.33 13.73-13.74-7.64-7.59a42.71 42.71 0 004.9-12.25zM97.71 107.1a29 29 0 1129-29 29 29 0 01-29 29z",
    stroke: "url(#SVGID_0_a224eab0e8307ff0133a91ea32827e3e56b058c1423349fb93f3ffb6388480f5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.eac5a26e95107080675d71428f475d01.svg";
export { ForwardRef as ReactComponent };